/* eslint-disable */

import {
  Box,
  Button,
  Divider,
  Group,
  SegmentedControl,
  Title,
  Modal,
  Text,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import AttendanceTable from "./components/AdminAttendanceTable";
import AttendanceDetail from "./components/AdminAttendanceDetail";
import { GridDots, List, Download } from "tabler-icons-react";
import Attendance from "features/attendance";
import { useDisclosure } from "@mantine/hooks";
import { PermissionButton } from "api/permission/buttonpermission";
import { useDownloadLeavesExcel } from "api/leaveReport/getLeaveReportDownload";

export default function AttendanceAdmin() {
  const [value, setValue] = useState("");
  const { mutate, isLoading } = useDownloadLeavesExcel();
  const [tableFilters, setTableFilters] = useState<any>({});
  const [opened, { open, close }] = useDisclosure(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const view = localStorage.getItem("AdminAttendanceView") ?? "list";
    setValue(view);
  }, []);

  const handleViewChange = (val: string) => {
    setValue(val);
    localStorage.setItem("AdminAttendanceView", val);
  };

  const handleExport = () => {
    mutate({
      startDate: tableFilters.startDate,
      endDate: tableFilters.endDate,
      department: tableFilters.department,
      status: tableFilters.status,
      leaveType: tableFilters.leaveType,
      search: tableFilters.search,
    });
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "100%" }}>
      <Modal
        opened={opened}
        onClose={close}
        centered
        size="md"
        radius="md"
        padding="xl"
        title={
          <Text fw={600} fz="lg">
            Confirm Excel Download
          </Text>
        }
      >
        <Text size="lg" mt="sm" mb="xl" color="dimmed">
          Are you sure you want to download the Attendance Report Excel file?
        </Text>

        <Group position="apart" mt="xl">
          <Button color="cancel" onClick={close} size="md">
            Cancel
          </Button>

          <Button
            size="md"
            loading={isLoading}
            onClick={() => {
              handleExport();
              close();
            }}
          >
            Yes, Download
          </Button>
        </Group>
      </Modal>

      <Group position="apart" align="center" mb="md">
        <Title order={2}>Attendance Admin</Title>

        <Group spacing="md">
          <PermissionButton
            permission="reports.leaveReportDownload"
            leftIcon={<Download size={16} />}
            onClick={open}
            loading={isLoading}
          >
            Attendance Download
          </PermissionButton>

          <SegmentedControl
            value={value}
            onChange={(e) => handleViewChange(e)}
            data={[
              { label: <GridDots size={16} />, value: "grid" },
              { label: <List size={16} />, value: "list" },
            ]}
            defaultValue="grid"
          />
        </Group>
      </Group>

      <Divider mb="md" />
      {value === "grid" ? (
        <Attendance />
      ) : (
        <>
          <AttendanceTable />
        </>
      )}
    </Box>
  );
}
